import React, { useEffect } from 'react';
import { updateFavicon } from '../../utlis';
import { API_URL } from '../../constants/api';
import { notification } from 'antd';
import axios from 'axios';

const AlnasiibPrivacy = () => {
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        //console.log(response.data.company);
        const company = response.data.company[0];

        // Set Favicon
        if (company?.logo) {
          const iconUrl = `${API_URL}/${company.logo}`;
          updateFavicon(iconUrl); // Replace with your image URL
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        notification.error({
          message: `Error ${error.response?.status}: ${error.response.data.message || 'Unknown error'}`,
        });
      }
    };
    fetchCompany();
    document.title = 'Privacy Policy – Alnasiib';
  }, []);
 
  const effectiveDate = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> {effectiveDate}
      </p>

      <p>
        This privacy policy explains how we collect, use, and share information
        about you when you use our mobile application ("App") available on
        Google Play Store.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Information:</strong> We do not collect personal
          information such as name, email, or phone unless explicitly provided.
        </li>
        <li>
          <strong>Non-Personal Information:</strong> We may collect device data
          (e.g., OS version, device type) and usage statistics for analytics and
          crash reports.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the collected information to:</p>
      <ul>
        <li>Improve app performance and features</li>
        <li>Understand usage patterns and fix bugs</li>
        <li>Comply with legal requirements</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <p>
        We may use third-party services such as Google Analytics, Firebase, or
        AdMob, which may collect anonymous usage data. These third-party
        services are governed by their own privacy policies.
      </p>

      <h2>4. Data Sharing</h2>
      <p>
        We do not sell, trade, or rent users’ personal identification
        information to others. Data may be shared only:
      </p>
      <ul>
        <li>With service providers under strict confidentiality agreements</li>
        <li>When required by law or to protect our rights</li>
      </ul>

      <h2>5. Children’s Privacy</h2>
      <p>
        Our app is not directed to children under 13. We do not knowingly
        collect personal data from children under 13. If we become aware of it,
        we will delete such data promptly.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain collected data as long as necessary to provide services and
        comply with our legal obligations.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal data. You
        may contact us at the email below to make a request.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. Updates will be posted on
        this page with a new effective date.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions or concerns, contact us at:</p>
      <p>
        <strong>Email:</strong> privacy@kaafiye.net
      </p>
      <p>
        <strong>Developer/Company:</strong> Kaafiye Technology Center
      </p>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    margin: "2rem",
    lineHeight: 1.6,
    backgroundColor: "#fff",
    color: "#333",
  },
  heading: {
    color: "#2c3e50",
  },
} 

export default AlnasiibPrivacy;
